import React, { useEffect, useState } from "react";
import { Image, SafeArea } from "antd-mobile";
import Mine from "@/pages/Mine";
import Home from "@/pages/Home";
import Members from "@/pages/Members";
import Finance from "@/pages/Finance";
import { createUseStyles } from "react-jss";
import useRouter from "@/hooks/useRouter";
import { findIndex } from "lodash";
import { pxToRem } from "@/util/common";
import { useDispatch } from "react-redux";
import { AppDispatch } from "@/redux/store";
import { Outlet } from "react-router-dom";
import {
	getUserInfoMethod,
	postApiFinanceBalance,
} from "@/redux/reducers/authSlice";
import useCustomTranslation from "@/hooks/useTranslation";

const tabs = [
	{
		key: "/home",
		title: "menuHome",
		icon: "home",
		element: <Home />,
	},
	{
		key: "/members",
		title: "menuMembers",
		icon: "members",
		element: <Members />,
	},
	{
		key: "/finance",
		title: "menuFinance",
		icon: "finance",
		element: <Finance />,
	},
	{
		key: "/mine",
		title: "menuMe",
		icon: "me",
		element: <Mine />,
	},
];

const Init: React.FC = () => {
	const classes = useStyles();
	const dispatch: AppDispatch = useDispatch();
	const { t } = useCustomTranslation();
	const { customNavigate, location } = useRouter();
	const [selectedTab, setSelectedTab] = useState(tabs[0].key);

	const setRouteActive = (value: string) => {
		customNavigate(value, { replace: true });
		setSelectedTab(value);
	};

	useEffect(() => {
		// 在组件挂载时更新用户信息
		const pathname = location.pathname;
		let InitKeyActive = tabs[0].key;

		const index = findIndex(tabs, { key: pathname });
		if (index !== -1) {
			InitKeyActive = tabs[index].key;
			setRouteActive(InitKeyActive);
		} else if (!pathname.startsWith("/game")) {
			customNavigate("/home", { replace: true });
		}
	}, [location.pathname]);

	const updateUserInfo = async () => {
		try {
			if (selectedTab === "/home") {
				await dispatch(postApiFinanceBalance({ itemTypes: [2] }));
			}
			await dispatch(getUserInfoMethod());
		} finally {
			console.log("updateUserInfo");
		}
	};

	useEffect(() => {
		updateUserInfo();
	}, [selectedTab]);

	return (
		<div className={classes.app}>
			<div style={{ background: "transparent" }}>
				<SafeArea position="top" />
			</div>
			<div className={classes.body}>
				<Outlet />
			</div>
			<div className={classes.bottom}>
				<ul>
					{tabs.map((item, index) => {
						const _index = findIndex(tabs, { key: selectedTab });
						let icon = item.icon;
						return (
							<li
								onClick={() => {
									setRouteActive(item.key);
								}}
								key={item.key}
								className={`${
									_index === index ? "active" : ""
								}`}
							>
								<Image
									className="icon"
									src={require(`@/assets/images/tabBar/${icon}.png`)}
								/>
								<Image
									className="on"
									src={require(`@/assets/images/tabBar/${icon}_on.png`)}
								/>
								<p>{t(item.title)}</p>
							</li>
						);
					})}
				</ul>
			</div>
		</div>
	);
};

export default Init;

const useStyles = createUseStyles({
	app: {
		height: "100vh",
		display: "flex",
		flexDirection: "column",
	},
	body: {
		flex: "1",
		width: "100vw",
		overflow: "hidden",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	bottom: {
		paddingTop: pxToRem(24),
		height: pxToRem(90),
		paddingBottom: pxToRem(12),
		background: "linear-gradient(156deg, #181B24 5.2%, #232C48 97.46%)",
		position: "relative",
		zIndex: 10,
		"& ul": {
			display: "flex",
			height: "100%",
			"& li": {
				display: "flex",
				flexDirection: "column",
				justifyContent: "end",
				alignItems: "center",
				position: "relative",
				flex: 1,
				cursor: "pointer",
				"& .icon": {
					width: pxToRem(28),
					// height: pxToRem(30),
					marginBottom: pxToRem(10),
				},
				"& .on": {
					position: "absolute",
					top: pxToRem(-42),
					width: pxToRem(76),
					height: pxToRem(76),
					display: "none",
				},
				"& p": {
					color: "#96B2C6",
					fontSize: pxToRem(13),
					fontWeight: "400",
				},
				"&.active": {
					"& .on": {
						display: "block",
					},
					"& p": {
						color: "#FFFFFF",
					},
				},
			},
		},
	},
});
